import useSwr from "@/core/composables/swr/useSwr";
import {consumerProductApi} from "@/container";
import {computed} from "vue";

/**
 * Composable to fetch consumer products.
 */
const useConsumerProducts = (consumerKey?: string) => {
    const {data: response, ...others} = useSwr(
        consumerKey ? `consumers/${consumerKey}/products` : undefined,
        () => consumerKey ? consumerProductApi().index(consumerKey) : Promise.resolve({
            data: [],
            meta: undefined
        })
    );

    /**
     * Get the products from the consumer products array.
     */
    const products = computed(() => {
        if (!response.value) {
            return undefined;
        }

        return response.value.data.map(item => item.product);
    });

    const _data = computed(() => {
        return response.value?.data;
    });

    return {
        data: _data,
        meta: response.value?.meta ?? null,
        products,
        ...others
    };
};

export default useConsumerProducts;
